import React, { useEffect, useState } from 'react';
import Styled from 'styled-components';

const Img = Styled.img `
  max-width: 100%;
  height: auto;
`

const Image = ({ src, fallback, onError, ...props }) => {
  const [imageSource, setImageSource] = useState(src || fallback);

  useEffect(() => {
    setImageSource(src || fallback);
  }, [src, fallback]);

  const handleError = (event) => {
    if (fallback && imageSource !== fallback) {
      setImageSource(fallback);
    }

    if (onError) {
      onError(event);
    }
  };

  return (
    <Img src={imageSource} onError={handleError} {...props} />
  )
}

export default React.memo(Image)
